import { api_request } from 'Services/helpers'

export const fetch = async (id) => {
  return await api_request('get', '/auth/vehicle/detail/' + id, {}, true)
}
